import { type FacilityUser } from '@reliance/types/models/FacilityUser';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService, type QueryParams } from '../types/ApiService';

export const facilityUser = (centralApi: ApiService) => ({
  index: (
    params: QueryParams = {},
  ): Promise<PaginatedResponse<FacilityUser>> => {
    return centralApi.get('/facility-user', { params });
  },
  post: (data: object | null = null) => {
    return centralApi.post('/facility-user', data);
  },
  put: (id: number, data: object | null = null) => {
    return centralApi.put(`/facility-user/${id}`, data);
  },
  putSignature: (
    id: number,
    signature: string,
  ): Promise<{ success: boolean }> => {
    return centralApi.put(`/facility-user/${id}/signature`, {
      inmateRequestSignature: signature,
    });
  },
});
